/**
 * Created by Jerker Nord on 2022-10-24.
 */
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {BenjiKIV} from "../../BenjiKIV";
import {BenjiKIVGameMode} from "../../server/BenjiKIVGameMode";
import {gsap} from "gsap";

export class BenjiKIVRespinTriggeredRunner implements SimplePresentation {

    private _mainTL:gsap.core.Timeline;

    public shouldRun():boolean {
        return (BenjiKIV.model.data.nextMode == BenjiKIVGameMode.NORMAL_EXTRA_SPIN && BenjiKIV.model.isRestore == false);
    }

    public start(controller:SimplePresentationRunnerController):void {
        this._mainTL = gsap.timeline();
        this._mainTL.add(BenjiKIV.respinTriggeredView.getNormalRespinAnimation());
        this._mainTL.add(()=>{controller.finish()}, "-=0.4");
    }
}